import {Component, Input} from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';

export class QueueMenuItem {
  constructor(
    readonly id: number | string,
    readonly icon: string,
    readonly title: string,
    readonly subtitle: string,
    readonly actionIcon: string,
    readonly iconColor: string,
    readonly inactivePredicate: () => boolean,
    readonly activePredicate: () => boolean,
    readonly queuedPredicate: () => boolean,
    readonly onClick: () => void,
    readonly onDelete: () => void,
  ) {}
}

@Component({
  selector: 'app-queue-menu-item',
  templateUrl: './queue-menu-item.component.html',
  styleUrls: ['./queue-menu-item.component.scss'],
  imports: [NgClass, MatIcon, CdkDragHandle, MatTooltip, MatIconButton],
})
export class QueueMenuItemComponent {
  @Input({ required: true }) input!: QueueMenuItem;

  onDeleteClick(event: MouseEvent): void {
    event.stopPropagation();
    this.input.onDelete();
  }
}
